/* eslint-disable */
import '@/js/desktop/plugins/select2';

import HotelsRepository from "@/js/common/Domain/Repository/Hotels";
import gaAsync from "@/js/common/Domain/Service/gaAsync";

import './hotelSearchTooltip.css';

let HotelView = Backbone.View.extend({
	label: 'Отель',
	searchModel: null,
	scrollToElement: function () {
		var currenPosition = $(document).scrollTop(),
			$filtersBlock = $('.sideBlock.filters'),
			windowHeight = $(window).height(),
			headerHeight = $('.headerContainer').height(),
			menuHeight = $('.menuContainer').height(),
			elementPosition,
			self = this,
			scrollTo;

		/*Force Open filters*/
		$filtersBlock.addClass('filtersOpened');

		elementPosition = this.$el.select2('container').offset().top;

		scrollTo = elementPosition;

		headerHeight ? scrollTo -= headerHeight : '';
		menuHeight ? scrollTo -= menuHeight : '';

		scrollTo -= 50;

		setTimeout(function () {
			$filtersBlock.addClass('filtersOpened');
			self.$el.select2("open");
		}, 1);

		if (elementPosition > currenPosition + windowHeight || elementPosition < currenPosition) {
			$("html,body").animate({scrollTop: scrollTo}, 200);
			return true;
		}

		return false;
	},
	dataForSelect2: null,
	select2Init: function (selection) {
		var self = this,
			format = function (item) {
				if (item) {
					if (item.text) {
						return item.text;
					} else if (item.get('category') && item.get('resort')) {
						return item.get('name') + ', ' + item.get('category').get('name') + ',  ' + item.get('resort').get('name');
					} else {
						return item.get('name');
					}
				} else {
					return '';
				}
			};

		return this.$el.select2({
			data: function () {
				return self.dataForSelect2;
			},
			ajax: {
				quietMillis: 500,
				data: function (params) {
					return {
						term: params
					};
				},
				results: function (data, page, query) {
					return self.generateSelectData({
						collection: data
					});
				},
				transport: function (params) {
					var currentTourCriteria = self.searchModel.getTourCriteria();

					currentTourCriteria.set('hotels', new HotelsRepository([]));
					HotelsRepository.repository.getHotels({
						tourCriteria: currentTourCriteria,
						term: params.data.term,
						pageType: self.pageType,
						callback: {
							success: params.success,
							error: params.error
						}
					});
				}
			},
			multiple: true,
			allowClear: true,
			minimumInputLength: 2,
			formatSelection: format,
			formatResult: format,
			containerCssClass: '',
			dropdownCssClass: 'hotelSearch',
			initSelection: function (element, callback) {
				callback(selection);
			}
		});
	},
	generateSelectData: function (params) {
		var self = this,
			data = {
				results: [],
				text: function (item) {
					return item.get('name');
				}
			};

		if (params.collection) {
			data.results = params.collection.models;
		}

		return data;
	},
	setSelectData: function (params) {
		self.dataForSelect2 = this.generateSelectData(params);
	},
	modelChanged: function (event, model, context) {
		if (!context || context.initiator !== 'view') {
			if (model === null) {
				this.$el.select2('disable');
			} else {
				this.$el.select2('enable');
				this.$el.select2('data', model.models ? model.models : '');
			}
		}
	},
	collectionChanged: function (event, collection, context) {
		this.setSelectData({
			collection: collection
		});
	},
	initEvents: function () {
		this.model.on('change:collection', $.proxy(this.collectionChanged, this));
		this.model.on('change:model', $.proxy(this.modelChanged, this));
		this.$el.on('select2-open', function () {
			gaAsync(function () {
				ga('set', 'dimension10', 'Hotel')
			});
		});
	},
	initialize: function (options) {
		var self = this;

		this.searchModel = options.searchModel;
		this.pageType = options.pageType;

		this.initEvents();

		this.setSelectData({
			collection: this.model.get('collection')
		});

		this.select2Init(this.model.get('model') !== null ? this.model.get('model').models : [])
			.on('change', function (e) {
				var data = new HotelsRepository(self.$el.select2("data"));
				self.model.set('model', data, {initiator: 'view'});

				self.searchModel.trigger('startSearch', {
					goToHotelPage: false,
					openBooking: false
				});

				console.log('Changed hotels to: ' + data.pluck('name').join(', '));
			});
		this.initDOMEvents();
	},
	initDOMEvents: function () {
		var self = this;
		$(window).on("scroll", function () {
			if (self.$el.select2) {
				self.$el.select2("close")
			}
		})
	}
});

export default HotelView;